// 需要 jquery
if (!customElements.get("roll-image-text")) {
    customElements.define(
      "roll-image-text",
      class RollImageText extends HTMLElement {
        constructor() {
          super();
          this.descs = $(this).find($(".rit_desc"));
          this.items = $(this).find($(".ric_img_item"));
          
          this.interval = null;
          this.initAutoRoll();
          this.addListenToItems();
        }
  
        initAutoRoll() {
          const that = this;
          let interval = setInterval(function () {
            let activeItem = $(that).find($(".ric_img_item.active"));
            let nextItem = activeItem.next('.ric_img_item');
            if(nextItem.length > 0){
              activeItem.removeClass("active");
              nextItem.addClass('active');
              let activeIndex = $(that).find($(".ric_img_item.active")).index();
              that.descs.eq(activeIndex).addClass('active').siblings().removeClass('active');
            } else {
              that.items.eq(0).addClass('active').siblings().removeClass('active');
              that.descs.eq(0).addClass('active').siblings().removeClass('active');
            }
          }, 4000);
          that.interval = interval;
        }
  
        addListenToItems() {
          const that = this;
          if (!that.descs || !that.items) return false;
          
          $(that.items).on('mouseenter',function(){
            clearInterval(that.interval);
            $(this).addClass('active').siblings().removeClass('active');
            let index = $(this).index();
            that.descs.eq(index).addClass('active').siblings().removeClass('active');
            that.initAutoRoll();
          })
        }
      }
    );
  }
  